import React, { useRef, useEffect } from 'react'
import type { SearchInputProps } from './types'
import SearchIcon from '../Icons/Search'

const MAX_WIDTH = 1086
declare const COMPILING_FOR_COMCASTX1: boolean

const Input = ({ searchQuery, showCursor }: SearchInputProps) => {
  const searchText = useRef<HTMLDivElement>(null)
  const searchInputText = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (searchText.current && searchInputText.current) {
      const isOverflowing = searchText.current.offsetWidth >= MAX_WIDTH

      searchInputText.current.classList.toggle(
        'search-screen__search-input-text--align-at-end',
        isOverflowing
      )
      searchText.current.classList.toggle(
        'search-screen__search-text--align-at-end',
        isOverflowing
      )
    }
  }, [searchQuery])

  return (
    <div className="input">
      <div className="input__icon-wrapper">
        <SearchIcon
          width="36px"
          height="36px"
          fill="#ababab"
          className="input__icon"
        />
      </div>
      <div className="input__result">
        <div className="input__input-text-wrapper" ref={searchInputText}>
          <div className="input__input-text" ref={searchText}>
            {searchQuery}
          </div>
          {showCursor && (
            <span
              className="input__cursor fake-cursor"
              style={{
                marginLeft: `${COMPILING_FOR_COMCASTX1 ? '0px' : '-7px'}`,
              }}
            >
              |
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default Input
